module.exports = __webpack_public_path__ + "img/stampa.118aaf22.svg";